import styled from 'styled-components';

const fieldColumnWidth = '270px';
const twoColumnRowGap = '16px';

export const RightSideColumns = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;

  .team-name,
  .view-jobs {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${twoColumnRowGap};
    max-width: calc(${fieldColumnWidth} * 2 + ${twoColumnRowGap});

    > * {
      flex: 1 1 ${fieldColumnWidth};
      width: ${fieldColumnWidth};
      min-width: 0;
      max-width: ${fieldColumnWidth};
    }
  }

  .team-name {
    padding: 20px 0 0;
  }

  .view-jobs-hint {
    position: relative;
  }
`;
